import React, { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { feeCollectionTableHeader } from './utils/feeCollectionTableHeader';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { ogdWings } from '../../../../utils/constants/GlobalStaticData';
import { Box, Grid } from '@mui/material';
import DatePickerCustom from '../../../../components/DatePicker/DatePickerCustom';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { getFeeCollection } from '../../../../redux/features/poinTrackerSlice';
import GlobalTableNoPagination from '../../../../components/CustomTableWithPagination/GlobalTableNoPagination';
import { getWingsUnderDeptId } from '../../../../redux/features/generalSlice';
import { ogdDepartmentId } from '../../../../utils/constants/departmentDetails';

export default function FeeCollectionsLanding() {
  const wingsUnderDeptId = useSelector((state) => state.general.wingsUnderDeptId);
  const feeCollection = useSelector((state) => state.pointTracker.feeCollection);
  const { responseData, loading } = feeCollection;
  const { data: wingsData } = wingsUnderDeptId;
  const teams = wingsData?.map((wing) => ({ id: wing.wing_id, value: wing.wing_name })) || ogdWings;
  const [selectedMonth, setSelectedMonth] = useState(dayjs().format('YYYY-MM-DD'));
  const [selectedTeam, setSelectedTeam] = useState({ id: -1, value: 'All' });
  const dispatch = useDispatch();
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: ['name', 'total'],
    hiddenColumns: [],
  });
  const dispatchParams = useMemo(() => {
    return {
      month: selectedMonth,
      wingId: selectedTeam.id === -1 ? null : selectedTeam.id,
    };
  }, [selectedMonth, selectedTeam.id]);

  useEffect(() => {
    dispatch(getFeeCollection(dispatchParams));
  }, [dispatchParams]);

  useEffect(() => {
    if (wingsData?.length === 0) {
      dispatch(getWingsUnderDeptId(ogdDepartmentId));
    }
  }, [wingsData]);
  const staticRow = useMemo(() => {
    let grandTotalObject = {
      userID: 100000,
      name: 'Daily Total',
      wingName: selectedTeam.value,
      wingId: selectedTeam.id,
      total: responseData?.meta?.grandTotal,
    };

    const modifiedDaysValueObject =
      responseData?.meta?.dailyTotals?.reduce((acc, day) => {
        acc[day.day] = `₹ ${day.amount}`;
        return acc;
      }, {}) || {};

    grandTotalObject = {
      ...grandTotalObject,
      ...modifiedDaysValueObject,
    };
    return grandTotalObject;
  }, [responseData, selectedTeam.id, selectedTeam.value]);

  const monthHeaders = useMemo(() => {
    const monthArray =
      responseData?.meta?.days ||
      Array.from({ length: dayjs().daysInMonth() }).map((v, i) => {
        return `${String(i + 1).padStart(2, '0')}/${String(dayjs().month() + 1).padStart(2, '0')}`;
      });
    return monthArray.map((date) => {
      return {
        field: date,
        headerName: date,
        width: 150,
      };
    });
  }, [responseData?.meta?.days]);

  const modifiedRows = useMemo(() => {
    if (!responseData?.data) return [];

    return responseData?.data?.map((row) => {
      const daysArray = row.metrics || [];

      const modifiedDaysValueObject = daysArray.reduce((acc, day) => {
        acc[day.day] = `₹ ${day.amount}`;
        return acc;
      }, {});

      return {
        ...row,
        ...modifiedDaysValueObject,
      };
    });
  }, [responseData?.data]);

    const styleString = `tbody tr:first-child {
    font-weight : 700 ;
    background : #f0f0f0;
    }`;
  return (
    <GlobalWrapper title={'Fee Collection'}>
      <Box
        mb={1}
        sx={{
          backgroundColor: 'white',
          borderRadius: '10px',
        }}
      >
        <Grid container spacing={{ xs: 1 }}>
          <Grid item xs={6} md={3}>
            <DatePickerCustom
              label="Month"
              value={dayjs(selectedMonth)}
              setValue={(date) => setSelectedMonth(date.format('YYYY-MM'))}
              viewDetails={['year', 'month']}
              fullWidth
              dateDisplayFormat="MM-YYYY"
            />
          </Grid>

          <Grid item xs={6} md={3}>
            <GlobalSelectFieldWithoutFormikNew
              keys={{ itemId: 'id', itemValue: 'value' }}
              data={[{ id: -1, value: 'All' }, ...teams]}
              label="Team"
              fullWidth
              selectedDetails={selectedTeam}
              setChange={setSelectedTeam}
            />
          </Grid>
        </Grid>
      </Box>
      <GlobalTableNoPagination
        headers={feeCollectionTableHeader(monthHeaders)}
        rows={modifiedRows}
        loading={loading}
        tableState={tableState}
        setTableState={setTableState}
        rowUniqueId={'userID'}
        addSerialNo={true}
        permanentFirstRow={staticRow}
        customeStyleString={styleString}
      />
    </GlobalWrapper>
  );
}
